import React from "react";
import { Link } from "react-router-dom";
import { FaSearch, FaUser, FaShoppingCart } from "react-icons/fa";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Shop from "./Shop";

const products = [
    {
      title: "Custom Pet PAWtrait - Canvas",
      image: "./dog11.jpeg",
      description: "Create a personalized canvas art piece featuring your pet! Perfect for any pet lover’s home.",
      price: "From ₹1,750",
      reviews: "⭐⭐⭐⭐ (2 reviews)",
      button:"Choose option"

    },
    {
      title: "Custom Pet PAWtrait Poster - Framed",
      image:"./dog22.jpeg" ,
      description: "Customize a poster of your pet, framed and ready to hang. A great gift idea!",
      price: "From ₹1,299",
      reviews: "⭐⭐⭐⭐ (If applicable)",
       button:"Choose option"
    },
    {
      title: "Custom Pet Printed T-shirt",
      image:"./dog33.jpeg" ,
      description: "Wear your pet’s image with pride on a comfy printed T-shirt! Available in various sizes.",
      price: "₹1,499",
      reviews: "⭐⭐⭐⭐ (If applicable)",
       button:"Choose option"
    },
    {
      title: "Custom Pet Printed Hoodies",
      image: "./dog44.jpeg",
      description: "Stay cozy and stylish with a hoodie that showcases your beloved pet.",
      price: "From ₹1,099",
      reviews: "⭐⭐⭐⭐ (1 review)",
       button:"Choose option"
    }
  ];
const ShopNavbar = () => {
  const categories = ["Dog Food", "Cat Food", "Customized Gifts", "Accessories", "Healthcare", "Home Services", "Store Locator"];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <div>
      <nav className="flex justify-between items-center px-8 py-4 border-b shadow-sm bg-white">
        <Link to="/" className="text-3xl font-bold text-blue-900">
          <span>Adopt</span><span className="text-orange-600">a</span><span>Pet</span>
        </Link>

        <div className="hidden md:flex items-center gap-6 text-sm text-gray-700">
          {categories.map((category, index) => (
            <Link key={index} to="/" className="hover:text-orange-600">
              {category} <span>&#9660;</span>
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-6 cursor-pointer text-gray-700 text-lg">
          <FaSearch />
          <FaUser />
          <FaShoppingCart />
        </div>
      </nav>

      <div className="relative">
        <Slider {...sliderSettings} className="overflow-hidden">
          <div className="w-full h-[400px] bg-gradient-to-r from-purple-300 to-pink-300 flex items-center justify-center">
            <div className="flex flex-col items-center text-center">
              <h2 className="text-4xl font-bold text-white">Whisker-Approved Delights</h2>
              <p className="text-xl text-white mt-2">Grab Up to 10% Off on Cat Food!</p>
              <button className="mt-4 px-6 py-2 bg-orange-600 text-white font-bold rounded-md">
                Discover More
              </button>
            </div>
          </div>
          <div className="w-full h-[400px] bg-gradient-to-r from-green-300 to-teal-300 flex items-center justify-center">
            <div className="flex flex-col items-center text-center">
              <h2 className="text-4xl font-bold text-white">Exclusive Dog Care Items</h2>
              <p className="text-xl text-white mt-2">Shop Now & Save More!</p>
              <button className="mt-4 px-6 py-2 bg-orange-600 text-white font-bold rounded-md">
                Explore Now
              </button>
            </div>
          </div>
        </Slider>
      </div>
      <div className=" p-4">
      <h1 className="text-4xl font-bold text-center mb-6">Customized Pet Gifts</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 md:gap-4">
        {products.map((product, index) => (
          <div key={index} className=" md:max-w-xs my-3 bg-white shadow-lg rounded-lg overflow-hidden">
            <img src={product.image} alt={product.title} className="w-full h-56 object-cover" />
            <div className="  p-4">
              <h3 className="text-xl font-semibold text-gray-800">{product.title}</h3>
              <p className="text-gray-600 mt-2">{product.description}</p>
              <p className="mt-4 font-bold text-gray-700">{product.price}</p>
              <p className="text-gray-500 mt-2">{product.reviews}</p>
              <button className="border-2 border-black rounded-2xl w-[200px] h-[50px] mt-6">{product.button}</button>
            </div>
          </div>
        ))}
      </div>
      <Shop/>
    </div>




    
    </div>
  );
};

export default ShopNavbar;
